// e.g. https://qiita.com/daishi/items/f12f524e9d1df0b52d2b
import { useEffect, useReducer, useCallback } from 'react';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { CUSTOMER_API_URL } from '../constants';

export type FetchStateType = {
  loading: boolean;
  error: AxiosError | null;
  data: AxiosResponse | null;
}
export type FetchActionType = 
  | { type: "init" }
  | { type: "start" }
  | { type: "success", data: AxiosResponse }
  | { type: "error", error: AxiosError }

export type FetchParameterType = {
  planId?: string;
  variantId?: string;
  quantity?: number;
  subscriptionId?: string,
  deliveryDays?: number,
  deliveryTime?: string,
}

export type FetchApiType = (params: FetchParameterType) => void;

const initialState: FetchStateType = {
  loading: false,
  error: null,
  data: null,
};

const reducer = (
  state: FetchStateType,
  action: FetchActionType
) => {
  switch (action.type) {
    case 'init': return initialState;
    case 'start': return { ...state, loading: true };
    case 'success': return { ...state, loading: false, data: action.data, error: null };
    case 'error': return { ...state, loading: false, error: action.error };
    default: throw new Error('no such action type.');
  }
};

export const useFetch = (
  action: string,
  token: string,
) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  let safeDispatch = (action: FetchActionType) => dispatch(action);
  const abortController = new AbortController();

  useEffect(() => {
    return () => {
      safeDispatch = () => null;
      abortController.abort();
      dispatch({ type: 'init' });
    };
  }, []);

  const fetchApi: FetchApiType = useCallback((params: FetchParameterType = {}) => {
    if (!action) return;

    return (async () => {
      safeDispatch({ type: 'start' });

      try {
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=${action}`,
          params,
          { headers: { Authorization: token } }
        );

        safeDispatch({ type: 'success', data: response.data });

      } catch (error) {

        if (axios.isAxiosError(error))
          safeDispatch({ type: 'error', error });
      }
    })();
  }, [action, token]);

  return [state, fetchApi];
};
